import React, {
  useContext,
  Fragment,
  useEffect,
  useRef,
  useState,
} from "react";
import { useMutation, useQuery } from "@apollo/react-hooks";
import PageScrollContext from "context/PageScrollContext";
import md5 from "crypto-js/md5";
import {
  Page,
  Range,
  ColorPicker,
  FormGroup,
  Input,
  Textarea,
  FormControl,
  Dropdown,
  Switch,
  CustomText,
  Icon,
  Button,
  Alert,
  VideoModal,
  RichEditor,
  ButtonSelect,
  MultiCurrencyModeAlerts,
  CodeEditor,
} from "components";
import PreviewContext from "context/PreviewContext";
import ShopContext from "context/ShopContext";
import UserContext from "context/UserContext";
import {
  GOOGLE_FONTS,
  CAMPAIGN_TYPES,
  SHOP_DEFAULT_SETTINGS,
  BREAK_POINTS,
} from "lib/globals";
import { SAVE_SHOP_SETTINGS, UPDATE_SHOP_PROP } from "lib/mutations";
import CheckoutButton from "screens/campaigns/settings/ExtraModules/CheckoutButton";
import { Loading, Toast, Modal } from "@shopify/app-bridge-react";

import { ShopConstraints } from "Constraints";
import removeTypeName, { removeByType } from "lib/removeTypeName";
import { Run } from "lib/validate";
import { GET_SHOP_SETTINGS, LIST_SHOP_CAMPAIGNS } from "Queries";
import { API, graphqlOperation } from "aws-amplify";
import { APP_DEV } from "aws-exports";
import Axios from "axios";
import { useTransition } from "react-spring";
import _ from "lodash";
import classNames from "lib/classNames";
import useReactRouter from "use-react-router";
import { SET_ALL, SET_ITEM } from "reducers/SetItemReducer";
import useRefState from "hooks/useRefState";
import { ScarcitySettings } from "./settings/scarcity";
import { BadgesSettings } from "./settings/badges";
import { TermsSettings } from "./settings/terms";
import AnnouncementSettings from "./settings/announcement";
import StaticFileIntegration from "./settings/StaticFileIntegration";
import { getSessionToken } from "@shopify/app-bridge-utils";
import EmbeddedContext from "context/EmbeddedContext";
import { trackMixPanelEvent } from "lib/mixpanel";
import { Redirect } from "@shopify/app-bridge/actions";
import { ReactComponent as Rotate } from "svgs/rotate.svg";
import { ReactComponent as Check } from "svgs/check.svg";
import { ReactComponent as Warning } from "svgs/warning.svg";
import "styles/custom.css";
import AfterPay from "./settings/afterPay";
import { getIn, setIn } from "immutable";

const CartScreen = (props) => {
  const {
    setCartIsEmpty,
    setAutoDiscount,
    setCheckoutButtonLoadingEdit,
    campaign_preview_types,
  } = useContext(PreviewContext);
  const stickyAlert = useRef(null);
  const { history, location } = useReactRouter();
  const [scrollTop, setScrollTop, scrollTopRef] = useRefState();
  const [cartActivateLoading, setCartActivateLoading] = useState(false);
  const [videoOne, setVideoOne] = useState(false);
  const [googleFonts, setGoogleFonts] = useState([]);
  const [hideTopBar, setHideTopBar] = useState(false);
  const [embedInstructionsCollapsed, setEmbedInstructionsCollapsed] =
    useState(false);
  const [showConfirmActivate, setShowConfirmActivate] = useState(false);
  const [showInstallationModel, setShowInstallationModel] = useState(false);

  const [campaignActive, setCampaignActive] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);

  const [cartType, setCartType] = useState("loading");
  const [cartTextPrimary, setCartTextPrimary] = useState(
    "Checking if Monster Cart is activated."
  );
  const [cartTextSecondary, setCartTextSecondary] = useState(
    "We are checking your theme to see if monster cart is activated"
  );
  const [cartButtonText, setCartButtonText] = useState("");
  const [cartButtonType, setCartButtonType] = useState("");

  const [campaign_preview_visible, setCampaign_preview_visible] =
    useState(false);
  const campaign_preview_content_ref = useRef(null);
  const shopContext = useContext(ShopContext);
  const { app, AppBridgeRedirect } = useContext(EmbeddedContext);
  const user = useContext(UserContext);
  const {
    state,
    discard,
    validationErrors,
    setValidationErrors,
    dispatch,
    setItem,
    AppLocalStorage,
    setup: { cartActive, cartLoading, setCartLoading },
  } = shopContext;
  const {
    campaigns,
    draft_checkout_alerted,
    multi_currency_checkout_alerted,
    static_file_eligible,
  } = state;
  // const filterSettings = (settings) =>
  // 	_.merge(
  // 		{},
  // 		SHOP_DEFAULT_SETTINGS(),
  // 		removeByType(
  // 			removeTypeName(
  // 				Object.fromEntries(Object.entries(settings).filter(([key]) => !['settingsSaved'].includes(key)))
  // 			),
  // 			(v) => v !== '' && v !== null
  // 		)
  // 	);
  const filterSettings = (settings) => {
    return removeByType(
      removeTypeName(
        Object.fromEntries(
          Object.entries(settings).filter(
            ([key]) => !["settingsSaved"].includes(key)
          )
        )
      ),
      (v) => v !== "" && v !== null
    );

    return (
      _.mergeWith(
        SHOP_DEFAULT_SETTINGS(),
        removeByType(
          removeTypeName(
            Object.fromEntries(
              Object.entries(settings).filter(
                ([key]) => !["settingsSaved"].includes(key)
              )
            )
          ),
          (v) => v !== "" && v !== null
        ),
        (v) => v !== "" && v !== null
      ),
      (objValue, srcValue) =>
        srcValue && _.isArray(srcValue) ? srcValue : undefined
    );
  };

  let [saveShopSettings, { data, error, loading }] = useMutation(
    SAVE_SHOP_SETTINGS,
    {
      refetchQueries: [
        {
          query: GET_SHOP_SETTINGS,
          variables: {
            userId: user.attributes.website,
          },
        },
      ],
    }
  );
  const transitions = useTransition(
    !_.isEqual(state.original_settings, state.settings) && !hideTopBar,
    null,
    {
      from: { position: "absolute", opacity: 0 },
      enter: { opacity: 1 },
      leave: { opacity: 0 },
      config: {
        duration: 300,
      },
    }
  );
  const validate = (state, specific = []) =>
    Run(state, specific, {
      errors: validationErrors,
      setErrors: setValidationErrors,
      constraints: ShopConstraints,
    });
  const save = (assign = {}, checkRTL = true) => {
    if (validate(state)) return;
    // if (
    //   checkRTL &&
    //   Object.keys(state.original_settings || {}).length &&
    //   state.settings.rtl !== state.original_settings.rtl
    // ) {
    //   return activateCart(state.settings.active, true, state.settings.rtl);
    // }

    if (!AppLocalStorage.getItem("first_cart_turn_on"))
      AppLocalStorage.setItem("first_cart_turn_on", true);

    saveShopSettings({
      variables: {
        id: user.attributes.website,
        input: filterSettings(Object.assign(state.settings, assign)),
      },
    });
  };

  let campaign_data = useQuery(LIST_SHOP_CAMPAIGNS, {
    variables: {
      userId: user.attributes.sub,
    },
    fetchPolicy: "network-only",
  });

  const activateCart = async (
    active,
    confirmed = false,
    rtl = null,
    disableLoading = true
  ) => {
    if (
      active &&
      !confirmed &&
      !state.settingsSaved &&
      _.isEqual(SHOP_DEFAULT_SETTINGS, state.settings)
    ) {
      return setShowConfirmActivate(true);
    }
    setCartActivateLoading(true);
    const { success } = await API.post("API_GATEWAY_NEW", "/cart/activate", {
      body: { active, rtl: rtl === null ? state.settings.rtl : rtl },
    });
    if (disableLoading) setCartActivateLoading(false);

    if (!AppLocalStorage.getItem("first_cart_turn_on")) {
      AppLocalStorage.setItem("first_cart_turn_on", true);
      trackMixPanelEvent("First cart turn ON", state?.id);
    }
    return save({ active }, false);
  };

  const handleOutSideClick = (event) => {
    if (!campaign_preview_content_ref.current) return;
    else if (campaign_preview_content_ref.current.contains(event.target))
      return;
    setCampaign_preview_visible(false);
  };

  const toggle_type = (type, value) => {
    if (value) {
      campaign_preview_types.set([
        ...new Set(campaign_preview_types.get.concat([type])),
      ]);
    } else {
      campaign_preview_types.set(
        campaign_preview_types.get.filter((c) => c !== type)
      );
    }
  };

  const type_is_active = (type) => {
    const typeIndex = campaign_preview_types.get.indexOf(type);
    return typeIndex !== -1 ? true : false;
  };

  useEffect(() => {
    if (campaign_preview_visible)
      document.addEventListener("mousedown", handleOutSideClick, false);
    else document.removeEventListener("mousedown", handleOutSideClick, false);
    return () => {
      document.removeEventListener("mousedown", handleOutSideClick, false);
    };
  }, [campaign_preview_visible]);

  useEffect(() => {
    const { data } = campaign_data;
    if (data) {
      if (data.campaigns?.list?.length) {
        setCampaignActive(
          !!data.campaigns.list.find((campaign) => campaign.active)
        );
      }
      setDataLoading(false);
    }
  }, [campaign_data]);

  useEffect(() => {
    // if (typeof state.settings.multiCurrencyMode !== 'boolean') {
    // 	setItem('settings.multiCurrencyMode', false);
    // }
    async function getGoogleFonts() {
      const { data } = await Axios.get(
        `https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyCYLq50twmAe1_7jITZuehrERZWOjNqBCY`
      );
      setGoogleFonts(
        data.items.map(({ family, variants }) => ({
          label: family,
          value: `${family}:${variants.join()}`,
        }))
      );
    }
    getGoogleFonts();
  }, []);

  const redirectToCheckoutSettings = (e) => {
    e.preventDefault();
    if (!scrollTopRef.current) return;
    const padding =
      1.5 * parseFloat(getComputedStyle(document.documentElement).fontSize);
    scrollTopRef.current(
      document
        .getElementById(`id_${md5("checkout settings")}`)
        .closest(".mu-group-wrapper").offsetTop - 0
    );
  };

  const sticky_path = "settings.modules.checkout_button.fix_checkout_container";
  const lower_path = "settings.product.grow";
  
  const getCheckoutPosition = () => {
    const lower_checkout_container = getIn(
      shopContext.state,
      lower_path.split(".")
    );
    const fix_checkout_container = getIn(
      shopContext.state,
      sticky_path.split(".")
    );
    if (fix_checkout_container) return "sticky";
    if (lower_checkout_container) return "lower";
    return "higher";
  };

  const [checkoutPosition, setCheckoutPosition] = useState(
    getCheckoutPosition()
  );

  const handleCheckoutPosition = (value) => {
    const isSticky = value === "sticky";
    const isLower = value === "lower";

    setIn(shopContext.state, sticky_path.split("."), isSticky);
    shopContext.setItem(sticky_path, isSticky);

    setIn(shopContext.state, lower_path.split("."), isLower);
    shopContext.setItem(lower_path, isLower);

    setCheckoutPosition(isSticky ? "sticky" : isLower ? "lower" : "higher");
  };

  const updateCheckoutText = (value) => {
    const path = "settings.modules.checkout_button.button_text.text";
    const checkout_text = getIn(shopContext.state, path.split("."));
    const regex = /(\{\s*)?\{\s*subtotal\s*\}\s*(\})?/gi;
    let new_text = checkout_text;

    if (value) {
      if (!regex.test(checkout_text)) {
        new_text += " / {{subtotal}}";
      }
    } else {
      new_text = checkout_text.replace(
        /\s*?\/?\s*-?\s*?\{\{\s*subtotal\s*\}\}\s*/,
        ""
      );
    }

    setIn(shopContext.state, path.split("."), new_text);
    shopContext.setItem(path, new_text);
  };

  const updateShopProps = async (input) => {
    const authToken = `Bearer ${await getSessionToken(app)}`;
    await API.graphql(
      graphqlOperation(
        UPDATE_SHOP_PROP,
        {
          id: user.attributes.website,
          input,
        },
        authToken
      )
    );
    Object.entries(input).forEach(([key, value]) => {
      setItem(key, value);
    });
  };

  useEffect(() => {
    setHideTopBar(!!data);
    if (APP_DEV) {
      const timeout = setTimeout(() => setHideTopBar(false), 1500);
      return () => clearTimeout(timeout);
    }
  }, [data]);

  useEffect(() => {
    if (state.settings.cod_settings.checkout_mode == "cod_and_checkout") {
      setItem("settings.cod_settings.is_form_in_cart", false);
    }
  }, [state.settings.cod_settings]);

  useEffect(() => {
    if (cartLoading) {
      setCartType("loading");
      setCartTextPrimary("Checking if Monster Cart is activated.");
      setCartTextSecondary(
        "We are checking your theme to see if monster cart is activated"
      );
      setCartButtonText("");
      setCartButtonType("");
    } else {
      if (cartActive) {
        setCartType("success");
        setCartTextPrimary(
          "Monster Cart is <span style='color: #3FB36D;'>active on theme</span>"
        );
        setCartTextSecondary(
          "Your cart is currently active on your live theme."
        );
        setCartButtonText("Disable");
        setCartButtonType("default");
      } else {
        setCartType("warning");
        setCartTextPrimary("Monster Cart is not activated on your theme.");
        setCartTextSecondary(
          "Click “activate” and then click “save” in your theme editor."
        );
        setCartButtonText("Activate");
        setCartButtonType("warning2");
      }
    }
  }, [cartActive, cartLoading]);

  return (
    <Page
      background="none"
      getScrollTop={({ scrollTop }) => {
        setScrollTop(scrollTop);
      }}
      padding={0}
      header={{
        title: "Settings",
      }}
      TopContent={{
        transitions,
        render: () => (
          <Alert
            type="save_settings"
            title="unsaved changes"
            borderPosition="none"
            paddingX="px-6"
            actions={[
              {
                text: "Discard",
                type: "secondary",
                loading: false,
                onClick: () => discard(),
              },
              {
                text: "Save",
                type: "primary",
                loading: loading || cartActivateLoading,
                onClick: () => save(),
              },
            ]}
          />
        ),
      }}
    >
      <Fragment>
        {data && (
          <Toast
            content="Cart settings has been saved"
            duration={3000}
            onDismiss={() => {
              setHideTopBar(false);
            }}
          />
        )}
        {(loading || cartActivateLoading) && <Loading />}
        {/* <div className={classNames("bg-white rounded overflow-hidden shadow mb-10")}>
          <div className={classNames("flex-center border-b px-3 py-1 text-gray-600")}>
            <b className={classNames("flex-1 font-semibold text-base uppercase-first")}>Activation instructions</b>
            <button className={classNames("w-10 h-10 flex-center hover:bg-gray-200 rounded-full focus:outline-none")} onClick={() => setEmbedInstructionsCollapsed(!embedInstructionsCollapsed)}>
              <Icon icon="angle-up" style={{
                transform: embedInstructionsCollapsed ? "rotate(180deg)" : undefined
              }}
              />
            </button>
          </div>
          <div className={classNames("text-gray-600 text-sm")} style={{
            height: embedInstructionsCollapsed ? 0 : undefined
          }}>
            <div className={classNames("p-3")}>
              <div className={classNames("leading-loose mb-3")}>
                <p>When you click "Preview in theme" you will be redirected to your Shopify theme editor where you can turn your cart ON and OFF.</p>
                <p>All you need to do is enable/disable MonsterUpsells and click save.</p>
              </div>
              <img className={classNames("border rounded")} src={`${window.location.origin}/static/images/embed-screenshot.jpg`} />
              <div className={classNames("flex flex-row-reverse mt-3")}>
                <Button type="primary" text="Preview in theme" className={classNames("ml-3")} />
                <Button type="secondary" text="Watch video tutorial" />
              </div>
            </div>
          </div>
        </div> */}
        <Alert
          type={cartType}
          title={cartTextPrimary}
          className="z-5"
          icon={
            cartLoading ? (
              <Rotate className="rotating" />
            ) : cartActive ? (
              <Check />
            ) : (
              <Warning />
            )
          }
          customSvg={true}
          actions={
            !cartLoading && [
              {
                text: cartButtonText,
                type: cartButtonType,
                loading: cartLoading,
                onClick: async () => {
                  setCartLoading(true);
                  if (!state.settingsSaved) {
                    await save();
                  }
                  setShowInstallationModel(true);
                },
              },
            ]
          }
        >
          <p>{cartTextSecondary}</p>
        </Alert>
        {!AppLocalStorage?.getItem("first_cart_turn_on") && (
          <Alert type={"info"} className="z-5 mt-4">
            <p
              className={classNames(
                "text-gray-600 text-md not-italic font-medium"
              )}
            >
              Nearly there! ... Design Your Cart, Click “Save” {">>"} Then Click
              “Activate”
            </p>
          </Alert>
        )}
        {cartActive && !campaignActive && !dataLoading && (
          <Alert
            type={"info"}
            className="z-5 mt-4"
            actions={[
              {
                text: "Add Upsell",
                type: "info",
                onClick: () => {
                  history.push("/campaigns/create" + location.search);
                },
              },
            ]}
          >
            <p
              className={classNames(
                "text-gray-600 text-md not-italic font-medium"
              )}
            >
              Cart is live! 👏 Now add your first upsell campaign.
            </p>
          </Alert>
        )}
        <Modal
          size="Large"
          title="Installation"
          open={!!showInstallationModel}
          primaryAction={{
            content: "Open Editor",
            onAction: function () {
              const activateAppId = APP_DEV
                ? "13fae760-4743-463c-aaeb-80cebaccc364"
                : "a1b8e58a-bf1d-4e0f-8768-a387c3f643c0";
              const deepLink = `/themes/current/editor?context=apps&template=product&activateAppId=${activateAppId}/app-embed`;
              AppBridgeRedirect.dispatch(Redirect.Action.ADMIN_PATH, {
                path: deepLink,
                newContext: true,
              });
            },
          }}
          secondaryActions={[
            {
              content: "Watch Tutorial",
              onAction: () => {
                AppBridgeRedirect.dispatch(Redirect.Action.REMOTE, {
                  url: "https://monsterapps.crisp.help/en/article/activate-deactivate-monster-cart-19okfn1/",
                  newContext: true,
                });
              },
            },
          ]}
          src={`${window.location.origin}/AppThemeExtensionInstallation.html`}
          onClose={() => setShowInstallationModel(false)}
        />
        <Alert
          {...{
            forwardRef: stickyAlert,
            type: state.settings.active ? "success" : "warning",
            title: `custom cart is ${
              state.settings.active ? "enabled" : "disabled"
            }`,
            withSwitch: {
              context: [
                shopContext,
                "settings.active",
                (value) => activateCart(value),
              ],
            },
            icon: state.settings.active ? "check-circle" : "exclamation-circle",
          }}
          className="z-5 hidden"
        >
          {state.settings.active && (
            <p>
              Cart button not working? Click to{" "}
              <span
                href="#"
                className={classNames("font-bold underline cursor-pointer")}
                onClick={() => {
                  history.push("/settings/setup" + location.search);
                }}
              >
                manually setup
              </span>
            </p>
          )}
          {!state.settings.active && (
            <p>Customize default cart settings / visuals and set it live.</p>
          )}
        </Alert>
        {static_file_eligible && <StaticFileIntegration setItem={setItem} />}
        {/* {campaigns.length === 0 && (
          <Alert
            {...{
              type: "warning",
              borderPosition: "border-l-4",
              iconSize: "2x",
              title: "Create your first campaign",
              icon: "exclamation-circle",
              customStyle: {
                icon: "text-orange-400 self-start mt-1",
              },
            }}
            className="my-6 z-5"
          >
            <p>Visit Campaign Page To Create Your 1st Upsell Campaign.</p>
            <div className={classNames("flex space-x-3 pt-3 justify-start")}>
              <a
                className={classNames(
                  "text-gray-800 text-sm flex items-center hover:text-orange-500 focus:outline-none focus:outline-shadow font-semibold py-1 px-2 uppercase border bg-orange-200 bg-opacity-50 border-orange-300 rounded"
                )}
                onClick={() =>
                  history.push("campaigns/create" + location.search)
                }
              >
                <Icon icon="info-circle" className="mr-2" size="1x" />
                <span className={classNames("text-xs")}>Create campaign</span>
              </a>
            </div>
          </Alert>
        )} */}

        <Modal
          title="Activating custom cart"
          message="You're about to activate the cart with the default settings"
          open={!!showConfirmActivate}
          primaryAction={{
            content: "Activate",
            destructive: true,
            onAction: () => {
              setShowConfirmActivate(false);
              activateCart(true, true);
            },
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => {
                setShowConfirmActivate(false);
                discard();
              },
            },
          ]}
        />
        <MultiCurrencyModeAlerts
          {...{
            ...state,
            redirectToCheckoutSettings,
            IUnderstand: updateShopProps,
          }}
        />

        <FormGroup
          label="Basic Cart Design"
          info="Design theme of cart"
          collapsable
          isOpen={false}
        >
          <FormControl label="Default language">
            <Dropdown
              options={[
                { value: "english", label: "English" },
                { value: "french", label: "Français" },
                { value: "german", label: "German" },
                { value: "arabic", label: "العربية" },
              ]}
              first
              autoFocus={true}
              BindToContext={[
                shopContext,
                "settings.default_language",
                (language) => {
                  dispatch({
                    type: SET_ALL,
                    value: {
                      ...state,
                      settings: SHOP_DEFAULT_SETTINGS(language),
                    },
                  });
                },
                "settings",
              ]}
            />
          </FormControl>
          <FormControl
            label="Colors"
            error={validationErrors["settings.theme.background"]}
          >
            <ColorPicker
              text="Primary"
              BindToContext={[
                shopContext,
                "settings.theme.primary",
                (value) => {
                  dispatch({
                    type: SET_ALL,
                    value: {
                      ...state,
                      settings: {
                        ...state.settings,
                        modules: {
                          ...state.settings.modules,
                          checkout_button: {
                            ...state.settings.modules.checkout_button,
                            background: value,
                            savings: {
                              ...state.settings.modules.checkout_button.savings,
                              color: value,
                            },
                          },
                        },
                        theme: {
                          ...state.settings.theme,
                          primary: value,
                        },
                      },
                    },
                  });
                },
              ]}
            />
            <ColorPicker
              text="Secondary"
              BindToContext={[shopContext, "settings.theme.secondary"]}
            />
            <ColorPicker
              text="Text On Cart"
              BindToContext={[
                shopContext,
                "settings.theme.textColor",
                (value) => {
                  dispatch({
                    type: SET_ALL,
                    value: {
                      ...state,
                      settings: {
                        ...state.settings,
                        modules: {
                          ...state.settings.modules,
                          checkout_button: {
                            ...state.settings.modules.checkout_button,
                            subtotal: {
                              ...state.settings.modules.checkout_button
                                .subtotal,
                              color: value,
                            },
                          },
                        },
                        theme: {
                          ...state.settings.theme,
                          textColor: value,
                        },
                        product: {
                          ...state.settings.product,
                          //   title: {
                          //     ...state.settings.product.title,
                          //     color: value,
                          //   },
                          price: {
                            ...state.settings.product.price,
                            color: value,
                          },
                        },
                      },
                    },
                  });
                },
              ]}
            />
            <ColorPicker
              text="Text On Buttons"
              BindToContext={[
                shopContext,
                "settings.theme.buttonColor",
                (value) => {
                  dispatch({
                    type: SET_ALL,
                    value: {
                      ...state,
                      settings: {
                        ...state.settings,
                        modules: {
                          ...state.settings.modules,
                          checkout_button: {
                            ...state.settings.modules.checkout_button,
                            button_text: {
                              ...state.settings.modules.checkout_button
                                .button_text,
                              color: value,
                            },
                          },
                        },
                        theme: {
                          ...state.settings.theme,
                          buttonColor: value,
                        },
                      },
                    },
                  });
                },
              ]}
            />
            <ColorPicker
              text="Background"
              BindToContext={[shopContext, "settings.theme.background"]}
            />
          </FormControl>
          <FormControl
            label="default font size"
            info="This font effects all other cart font sizes"
            error={validationErrors["settings.font.size"]}
          >
            <Input
              type="number"
              icon={{ char: "PX" }}
              max={18}
              min={12}
              BindToContext={[shopContext, "settings.font.size"]}
              hasError={!!validationErrors["settings.font.size"]}
            />
          </FormControl>
          <FormControl
            label="font family"
            withSwitch={[shopContext, "settings.font.custom"]}
            info="By default the cart will use your store theme font. Turn this section on to add a custom google font."
          >
            <Dropdown
              disabled={!state.settings.font.custom || !googleFonts.length}
              options={googleFonts}
              first
              BindToContext={[shopContext, "settings.font.family"]}
            />
          </FormControl>
        </FormGroup>
        <FormGroup
          label="advanced design settings"
          info="Finetune Cart Visuals"
          collapsable
        >
          <FormGroup label="header" fullWidth>
            <CustomText
              context={shopContext}
              label="cart title"
              path="settings.header.title"
              hasWeight="700"
              // info="The em unit is relative to the font size (2em means 2 times the current font size)"
            />
            <FormControl
              label="header colors"
              error={validationErrors["settings.header.background"]}
            >
              <ColorPicker
                text="text"
                BindToContext={[shopContext, "settings.header.title.color"]}
              />
              <ColorPicker
                text="background"
                BindToContext={[shopContext, "settings.header.background"]}
              />
            </FormControl>
          </FormGroup>
          <FormGroup
            label="cart"
            info="Design the basic cart visuals"
            fullWidth
          >
            <CustomText
              context={shopContext}
              label="product title"
              path="settings.product.title"
              hasColor={true}
              hasWeight="700"
            />
            <CustomText
              context={shopContext}
              label="product price"
              path="settings.product.price"
              hasColor={true}
              hasWeight="700"
            />
            <FormControl
              label="product image size"
              info="an integer between 50 and 120"
              error={validationErrors["settings.product.image_size"]}
            >
              <Input
                type="number"
                BindToContext={[shopContext, "settings.product.image_size"]}
                min={50}
                max={120}
              />
            </FormControl>
            <FormControl
              label="Checkout Button Position"
              info={
                "Sticky: Always Visible At Bottom of cart (Suggested)\nLower: Sits at Bottom of Page until product push it down further.\nHigher: Sits Under Product Section And Scrolls Down as more products are added."
              }
            >
              <Dropdown
                options={[
                  {
                    value: "sticky",
                    label: "Sticky",
                  },
                  {
                    value: "higher",
                    label: "Higher",
                  },
                  {
                    value: "lower",
                    label: "Lower",
                  },
                ]}
                value={checkoutPosition}
                onChange={handleCheckoutPosition}
              />
            </FormControl>
            {/* <FormControl
              label="lower checkout button"
              info="Checkout button will sit at the bottom of screen unless products push it lower."
              error={validationErrors["settings.product.grow"]}
            >
              <Switch BindToContext={[shopContext, "settings.product.grow"]} />
            </FormControl>
            <FormControl
              label="sticky checkout button"
              info="Keeps the checkout button fixed at the bottom, always visible and not pushed down by products."
              error={
                validationErrors[
                  "settings.modules.checkout_button.fix_checkout_container"
                ]
              }
            >
              <Switch
                BindToContext={[
                  shopContext,
                  "settings.modules.checkout_button.fix_checkout_container",
                ]}
              />
            </FormControl> */}
            <FormControl
              label="subtotal within checkout"
              info="Choose to integrate the subtotal within the checkout button or display it separately."
              error={
                validationErrors[
                  "settings.modules.checkout_button.show_subtotal"
                ]
              }
            >
              <Switch
                BindToContext={[
                  shopContext,
                  "settings.modules.checkout_button.show_subtotal",
                  updateCheckoutText
                ]}
              />
            </FormControl>
            <FormControl
              label="Add to cart opens Cart"
              info="Every time a customer adds to cart the slide cart will appears. (We recommended leaving this on.)"
              error={validationErrors["settings.open_cart"]}
            >
              <Switch BindToContext={[shopContext, "settings.open_cart"]} />
            </FormControl>
            <FormControl
              label="sold out"
              error={validationErrors["settings.product.sold_out"]}
            >
              <Input
                type="text"
                BindToContext={[
                  shopContext,
                  "settings.product.sold_out",
                  null,
                  "settings",
                ]}
                hasError={!!validationErrors["settings.product.sold_out"]}
              />
            </FormControl>
            <FormControl
              label="empty cart"
              info={`Displayed when no products are in the cart.
							Tip: you can add images`}
            >
              <RichEditor
                placeholder="empty cart text"
                BindToContext={[shopContext, "settings.empty_cart"]}
                onFocus={() => {
                  setCartIsEmpty(true);
                }}
                onBlur={(editor, activeElement) => {
                  if (!editor.contains(activeElement)) setCartIsEmpty(false);
                }}
              />
            </FormControl>
            <FormControl
              label="Empty cart - Continue shopping button"
              info="Make it easy for customers to continue shopping"
              withSwitch={[
                shopContext,
                "settings.active_continue_shopping_button",
              ]}
            >
              {state.settings.active_continue_shopping_button && (
                <CustomText
                  context={shopContext}
                  placeholder="Continue shopping"
                  hasColor={true}
                  path="settings.continue_shopping_button"
                  onFocus={() => {
                    setCartIsEmpty(true);
                  }}
                  onBlur={() => {
                    setCartIsEmpty(false);
                  }}
                  hasWeight={true}
                />
              )}
            </FormControl>
          </FormGroup>

          <FormGroup
            label="Auto discount style"
            onFocus={() => setAutoDiscount(true)}
            onBlur={() => setAutoDiscount(false)}
            fullWidth
          >
            <CustomText
              context={shopContext}
              label="text"
              path="settings.auto_discount.text"
              hasColor={true}
              hasWeight="700"
              beta
            />
            <FormControl>
              <ColorPicker
                text="Background"
                BindToContext={[
                  shopContext,
                  "settings.auto_discount.background",
                ]}
              />
              <ColorPicker
                text="Border"
                BindToContext={[shopContext, "settings.auto_discount.border"]}
              />
            </FormControl>
          </FormGroup>
          <CheckoutButton
            context={shopContext}
            setCheckoutButtonLoadingEdit={setCheckoutButtonLoadingEdit}
          />

          <FormControl
            label="display cart on RTL"
            withSwitch={[shopContext, "settings.rtl"]}
            info="Enable this if your store language uses right to left scripts."
          />
          <FormControl
            label="Curve corners"
            withSwitch={[shopContext, "settings.curved"]}
            info="Turn curved corners on and off."
          />
          <FormControl
            label="Display compare price"
            info="Show Shopify product compare pricing in cart."
            withSwitch={[shopContext, "settings.count_compare_at"]}
          />
        </FormGroup>
        <FormGroup
          label="extra features"
          info="Timer, Split Payments, Badges Banners ect."
          collapsable
        >
          <AfterPay shopContext={shopContext} />
          <ScarcitySettings {...{ shopContext }} />
          <BadgesSettings {...{ shopContext }} />
          <TermsSettings {...{ shopContext }} />
          <AnnouncementSettings {...{ shopContext }} />
        </FormGroup>
        <FormGroup label="advanced cart settings" collapsable>
          <FormGroup label="Custom CSS" fullWidth>
            <FormControl
              label="Manually Add Custom CSS Changes To The Cart."
              info={`This is helpful if you need to modify text sizes and introduce small branding elements.
							Reach out to the team if you need help finding specific id's. Styles will only be applied to live cart on your store not in dashboard preview. 
							(Advanced users only)`}
            >
              {/* <Textarea
              BindToContext={[shopContext, "settings.custom_css"]}
              placeholder=".text{ color: blue; }"
            /> */}
              <CodeEditor
                BindToContext={[shopContext, "settings.custom_css"]}
                language={"css"}
                placeholder="/* your css here */"
              />
            </FormControl>
          </FormGroup>
        </FormGroup>

        {!BREAK_POINTS["kill_draft"](shopContext) && (
          <FormGroup
            label="checkout settings"
            info={`
						<p class="${classNames(
              "mb-1"
            )}">To navigate Shopify’s limited discount functionalities we use draft discounts.</p>
						<h4 class="${classNames("font-bold text-gray-600 mb-1")}">Draft checkout:</h4>
						<p>has more discount functionality and is preferred option for upsells.</p>
						<h4 class="${classNames(
              "font-bold text-gray-600 mb-1"
            )}">Normal Shopify checkout:</h4>
						<p>works better for stores that sell in multi-currency and want customers to add discounts in checkout area.</p>
						`}
          >
            <ButtonSelect
              isVertical
              options={[
                {
                  label: "Draft Checkout",
                  value: false,
                  infoHtml: true,
                  info: `
								<ul class="${classNames("list-disc list-inside")}">
									<li>Allow multiple discounts</li>
									<li>More powerful campaign options</li>
									<li>Checkout is in default store currency</li>
									<li>Coupon must be added in upsell cart</li>
								</ul>
								`,
                },
                {
                  label: "Normal Shopify Checkout",
                  value: true,
                  infoHtml: true,
                  info: `
									<ul class="${classNames("list-disc list-inside")}">
									<li>One discount at a time</li>
									<li>Uses unique discount codes injected at checkout</li>
									<li>Checkout is in Multi-currency</li>
									<li>Coupons added in checkout like normal</li>
								</ul>
								`,
                },
              ]}
              BindToContext={[shopContext, "settings.multiCurrencyMode"]}
            />
          </FormGroup>
        )}

        {/* // COD */}
        {/* <FormGroup
          label="Cash On Delivery Checkout"
          info={`<p>Replace standard Shopify checkout process with our fully customizable COD checkout.</p>`}
          collapsable
        >
          <ButtonSelect
            isVertical
            options={[
              {
                label:
                  "Cash On Delivery Checkout - COD ( Shopify will not take any payments)",
                infoHtml: true,
                withSwitch: true,
                disabledClick: true,
                info: `
								<ul class="${classNames("list-disc list-inside")}">
									<li>Replace checkout with quick order form</li>
									<li>Creates Draft order for you to fullfill </li>
									<li>Skips all checkout payment options (example: Paypal, Shopify Payments, Afterpay)</li>
									<li>Creates customer orders/accounts for you to fullfill and collect payment for</li>
								</ul>
								`,
              },
            ]}
            BindToContext={[shopContext, "settings.cod_settings.is_active"]}
            showCheckedIcon={false}
          />
          {state.settings.cod_settings.is_active && (
            <>
              <FormControl
                label="Cash on delivery options"
                info="Would you like to give both checkout options or limit to just cash on delivery?"
                error={validationErrors["settings.cod_settings.checkout_mode"]}
                isSingleCol={true}
              >
                <ButtonSelect
                  options={[
                    { label: "Cash on Delivery only", value: "cod_only" },
                    {
                      label: "Checkout and cash on delivery",
                      value: "cod_and_checkout",
                    },
                  ]}
                  BindToContext={[
                    shopContext,
                    "settings.cod_settings.checkout_mode",
                  ]}
                />
              </FormControl>
              <FormControl>
                <div>
                  <Button
                    text="Customize COD Checkout"
                    onClick={() => {
                      history.push("/settings/checkout" + location.search);
                    }}
                    style={{ width: "100%" }}
                  />
                </div>
              </FormControl>
            </>
          )}
          {state.settings.cod_settings.checkout_mode == "cod_only" && (
            <FormControl
              label="one step checkout"
              withSwitch={[
                shopContext,
                "settings.cod_settings.is_form_in_cart",
              ]}
              info="Display the checkout form in the main cart for a fast onr step checkout."
            />
          )}
        </FormGroup> */}
      </Fragment>
    </Page>
  );
};

export default CartScreen;
